import React, { Fragment } from 'react';
import LoginModal from '../../LoginModal';
import { useState, useEffect } from 'react';
import { authActions } from '../../../store/auth-slice';
import NavItem from '../../Atoms/NavItem/index';
import FaBars from '@meronex/icons/fa/FaBars';
import { useMediaQuery, useTheme } from '@material-ui/core';
import FaTimes from '@meronex/icons/fa/FaTimes';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getConfig, routePathMap } from '../../../utils/config';
import setAuthToken from '../../../utils/authtoken';
import CartModal from '../../../Components/Organisms/CartModal';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Transition } from '@headlessui/react';
import { getFormattedUserName, updateCartCount } from '../../../helpers';
import { deleteWinnreAuthToken } from '../../../utils/axios';
import { isRewardsVisible } from '../../../utils/routing';
import SurveyForm from '../../../Components/Forms/surveyForm';
import { dealAction } from '../../../store/deal-slice';
import BiUser from '@meronex/icons/bi/BiUser';

const Overlay = ({ visible }) => {
    return (
        <div
            className={
                'fixed z-30 inset-0 bg-gray-700 bg-opacity-60 overflow-y-auto h-full w-full' +
                (visible ? ' block' : ' hidden')
            }
            id="my-modal"
        ></div>
    );
};

function NavBar({
    navBarConfig,
    showSurvey,
    cartCount
}) {
    const [showNavBar, setShowNavBar] = useState(false);
    const [showMMenu, setShowMMenu] = useState(false); //s
    const [clicked, setClicked] = useState(false); //s
    const [openMyProfile, setOpenMyProfile] = useState(false);
    const [isCartVisible, setIsCartVisible] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [openMobileDropdown, setOpenMobileDropdown] = useState(false);

    const config = getConfig();
    const location = useLocation();

    const dispatch = useDispatch();
    const theme = useTheme();
    const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));

    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => {
        setShowModal(false);
        // console.log(showModal);
    };
    const [isCartUpdate, setIsCartUpdate] = useState(false);

    const { userName, userRole, isAuthenticated, isLoginModalVisible } =
        useSelector((state) => state.auth);

    useEffect(() => {
        window.addEventListener('scroll', transitionNavBar);

        return () => {
            window.removeEventListener('scroll', transitionNavBar);
        };
    }, []);

    // Mini survey Timer section
    useEffect(() => {
        if (showSurvey) {
            setShowModal(true);
        }
    }, [showSurvey]);

    const openLoginModal = () => {
        localStorage.removeItem('cartData');
        dispatch(authActions.openLoginModal());
    };
    // console.log('render navbar');
    const logout = () => {
        // localStorage.removeItem('token');
        if (config?.autoLogout) {
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('accessToken');
        } else {
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
        }
        localStorage.removeItem('cartData');
        // setAuthToken(false);
        window?.webengage?.track('LogOut');
        window?.webengage?.user?.logout();
        deleteWinnreAuthToken();
        dispatch(authActions.logout());
    };

    const handleClicks = () => {
        setClicked((prevState) => !prevState);

        if (clicked) {
            setShowMMenu(false);
        } else {
            setShowMMenu(true);
        }
    };

    const setClickFalse = () => {
        setClicked(false);
        setShowMMenu(false);
    };

    const handleCartClick = () => {
        if (cartCount > 0) {
            dispatch(dealAction.setCartModalVisible(true));
            window?.webengage?.track('DealViewedInCart');
            window.dispatchEvent(new Event('cartUpdated'));
        }
    };

    useEffect(() => {
        const isRewardStore = location?.pathname
            ?.toLowerCase()
            ?.includes('rewardstore');
        setIsCartVisible(isRewardStore);
    }, [location.pathname]);

    const transitionNavBar = () => {
        // alert(window.scrollY);
        if (window.scrollY > 100) {
            setShowNavBar(true);
        } else {
            setShowNavBar(false);
        }
    };

    const routeList = window.reloy_env.client_config.NAVIGATION_ROUTES;

    return (
        <>
            {/* {isLoginModalVisible && <LoginModal />} */}
            {/* {showMMenu && <Overlay visible={showMMenu} />} */}
  
            {!window.reloy_env.WEBFORM_ONLY && (
                <header
                class={`flex flex-col sticky top-0 z-30 mx-auto lg:items-center lg:justify-between lg:flex-row relative ${
                    showNavBar
                        ? config?.navBarConfig?.stickyHeight
                            ? config?.navBarConfig?.stickyHeight
                            : config?.navBarConfig?.height || 'h-20 '
                        : config?.navBarConfig?.height || 'h-20 '
                } ${config?.navBarConfig?.font}
            ${
                showNavBar
                    ? ` ${
                          config?.navBarConfig.stickyNavBar.backgroundColor ||
                          'bg-primary-content'
                      }  ${
                          config?.navBarConfig.stickyNavBar.border
                              ? `${config?.navBarConfig.stickyNavBar.borderClass}`
                              : ``
                      } `
                    : ` ${
                          config.navBarConfig.baseNavBar.backgroundColor ||
                          'bg-transparent'
                      } ${
                          config?.navBarConfig.baseNavBar.border
                              ? `${config?.navBarConfig.baseNavBar.borderClass}`
                              : ''
                      }
         `
            }`}
            >
                {/* LEFT LOGO */}
                {config?.logoLeft && (
                    <div className=" cursor-pointer flex flex-row px-3 lg:px-0  items-center justify-between h-full ">
                        <div className="flex items-center gap-2 lg:hidden ">
                            <button
                                onClick={() =>
                                    setOpenMobileDropdown((prev) => !prev)
                                }
                                className="lg:hidden rounded-lg focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    fill="currentColor"
                                    viewBox="0 0 50 50"
                                    className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                >
                                    {!openMobileDropdown && (
                                        <path d="M 3 9 A 1.0001 1.0001 0 1 0 3 11 L 47 11 A 1.0001 1.0001 0 1 0 47 9 L 3 9 z M 3 24 A 1.0001 1.0001 0 1 0 3 26 L 47 26 A 1.0001 1.0001 0 1 0 47 24 L 3 24 z M 3 39 A 1.0001 1.0001 0 1 0 3 41 L 47 41 A 1.0001 1.0001 0 1 0 47 39 L 3 39 z"></path>
                                    )}
                                    {openMobileDropdown && (
                                        <path
                                            onClick={() =>
                                                setOpenDropdown(false)
                                            }
                                            d="M 7.7070312 6.2929688 L 6.2929688 7.7070312 L 23.585938 25 L 6.2929688 42.292969 L 7.7070312 43.707031 L 25 26.414062 L 42.292969 43.707031 L 43.707031 42.292969 L 26.414062 25 L 43.707031 7.7070312 L 42.292969 6.2929688 L 25 23.585938 L 7.7070312 6.2929688 z"
                                        ></path>
                                    )}
                                </svg>
                            </button>
                        </div>
                        <Link
                            className="h-full flex justify-center items-center"
                            to="/"
                        >
                            <img
                                src={
                                    showNavBar
                                        ? config?.logoLeft?.stickyUrl ||
                                          config?.logoLeft?.url
                                        : config?.logoLeft?.baseUrl ||
                                          config?.logoLeft?.url
                                }
                                className={
                                    '  object-contain ' +
                                    (showNavBar
                                        ? `${config.logoLeft?.stickyNavBarLogoClass}`
                                        : `${config.logoLeft?.baseNavBarLogoClass}`)
                                }
                            />
                        </Link>

                        <div className="flex block lg:hidden space-x-3 ">
                            {!isAuthenticated && (
                                <button
                                    onClick={openLoginModal}
                                    // className={`text-left px-6 w-full py-2 lg:p-0 lg:border-none lg:w-auto lg:mr-6   uppercase text-primary hover:text-accent text-[14px] lg:text-[12px] xl:text-[14px] lg:mr-6     `}
                                    className={`text-left lg:border-none lg:w-auto lg:mr-6 uppercase text-[14px] lg:text-[12px] xl:text-[14px] ${
                                        showNavBar
                                            ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                            : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                    }  `}
                                >
                                    <BiUser
                                        className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                    />
                                </button>
                            )}

                            {isAuthenticated && userRole === 'CUSTOMER' && (
                                <NavLink
                                    className={
                                        ` block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                        (showNavBar
                                            ? `${
                                                  config?.navBarConfig
                                                      .stickyNavBar.itemClass ||
                                                  'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                              }`
                                            : ` ${
                                                  config.navBarConfig.baseNavBar
                                                      .itemClass ||
                                                  'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                              }`)
                                    }
                                    activeClassName={
                                        config.navBarConfig.showActiveLinkColor
                                            ? 'text-secondary-focus'
                                            : ''
                                    }
                                    to="/myprofile/info"
                                    onClick={setClickFalse}
                                >
                                    <BiUser
                                        className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                    />
                                    {/* <svg
                                        fill="currentColor"
                                        viewBox="0 0 32 32"
                                        className={` w-6 h-6 ${config?.navBarConfig.mobileIconColor}`}
                                    >
                                        <path d="M16 31C7.729 31 1 24.271 1 16S7.729 1 16 1s15 6.729 15 15-6.729 15-15 15zm0-28C8.832 3 3 8.832 3 16s5.832 13 13 13 13-5.832 13-13S23.168 3 16 3z" />
                                        <circle cx="16" cy="15.133" r="4.267" />
                                        <path d="M16 30c2.401 0 4.66-.606 6.635-1.671-.425-3.229-3.18-5.82-6.635-5.82s-6.21 2.591-6.635 5.82A13.935 13.935 0 0 0 16 30z" />
                                    </svg> */}
                                </NavLink>
                            )}

                            {isAuthenticated &&
                                isRewardsVisible &&
                                isCartVisible && (
                                    <button
                                        // onClick={() => setOpenCartModal(true)}
                                        onClick={handleCartClick}
                                        className={`relative  lg:hidden text-left border-none w-auto mr-1 mb-2 `}
                                    >
                                        <svg
                                            fill="currentColor"
                                            viewBox="0 0 22.427 25.887"
                                            className={`w-5 -mb-1 ${config?.navBarConfig.mobileIconColor}`}
                                        >
                                            <g
                                                id="bag"
                                                transform="translate(-3.005 -0.995)"
                                            >
                                                <path
                                                    id="Path_7704"
                                                    data-name="Path 7704"
                                                    d="M25.427,21.792,23.864,6.771A2.583,2.583,0,0,0,21.291,4.45H18.444a4.314,4.314,0,0,0-8.455,0H7.142A2.581,2.581,0,0,0,4.57,6.77L3,21.792v.086a5.01,5.01,0,0,0,5,5H20.428a5.01,5.01,0,0,0,5-5A.767.767,0,0,0,25.427,21.792ZM14.217,2.725A2.593,2.593,0,0,1,16.657,4.45H11.776a2.593,2.593,0,0,1,2.441-1.726Zm6.212,22.432H8A3.279,3.279,0,0,1,4.726,21.92L6.286,6.952a.863.863,0,0,1,.856-.776H21.291a.863.863,0,0,1,.863.776L23.707,21.92a3.278,3.278,0,0,1-3.278,3.236Z"
                                                    transform="translate(0 0)"
                                                />
                                                <path
                                                    id="Path_7705"
                                                    data-name="Path 7705"
                                                    d="M18.765,11a.863.863,0,0,0-.863.863,2.588,2.588,0,0,1-5.177,0,.863.863,0,1,0-1.726,0,4.314,4.314,0,0,0,8.628,0A.863.863,0,0,0,18.765,11Z"
                                                    transform="translate(-1.097 -1.373)"
                                                />
                                            </g>
                                        </svg>
                                        <span className="absolute w-[20px] h-[20px] border rounded-xl bottom-[10px] text-center bg-primary text-white left-[10px] text-xs font-medium">
                                            {cartCount}
                                        </span>
                                    </button>
                                )}
                        </div>
                    </div>
                )}
                {/* NAV */}

                <div>
                    {config?.logoCenter && (
                        <div class="hidden lg:block cursor-pointer flex flex-row items-center justify-center h-full">
                            <Link
                                className="h-full flex justify-center items-center"
                                to="/"
                            >
                                <img
                                    src={
                                        showNavBar
                                            ? config?.logoCenter?.stickyUrl ||
                                              config?.logoCenter?.url
                                            : config?.logoCenter?.baseUrl ||
                                              config?.logoCenter?.url
                                    }
                                    className={
                                        '  object-contain ' +
                                        (showNavBar
                                            ? `${config.logoCenter?.stickyNavBarLogoClass}`
                                            : `${config.logoCenter?.baseNavBarLogoClass}`)
                                    }
                                />
                            </Link>
                        </div>
                    )}

                    <ul
                        className={` lg:flex lg:items-center w-full absolute left-0 top-[100%] lg:static lg:left-auto lg:top-auto ${
                            showNavBar
                                ? `${config?.navBarConfig.stickyNavBar.containerClass}`
                                : `${config?.navBarConfig.baseNavBar.containerClass} `
                        } ${!config?.logoRight && 'lg:mr-7'}`}
                    >
                        <li className={`${
                                openMobileDropdown
                                    ? 'flex-col flex animate-dropDownOpen '
                                    : 'hidden'
                            } bg-primary-content lg:bg-transparent lg:flex-grow py-4 md:py-0 lg:flex md:justify-center lg:items-center lg:flex-row md:mx-auto `} onClick={setClickFalse}>
                            {Object.keys(routeList)
                                .sort(
                                    (a, b) =>
                                        routeList[a].order - routeList[b].order
                                )
                                .map((page) => {
                                    if (routeList[page]?.name == '') {
                                        return;
                                    } else
                                        return (
                                            <NavItem
                                                key={routeList[page].name}
                                                label={routeList[page].name}
                                                show={routeList[page].show}
                                                pathname={
                                                    routeList[page].path ||
                                                    routePathMap[page] ||
                                                    '/'
                                                }
                                                scrollTo={
                                                    routeList[page].scrollTo
                                                }
                                                customUrl={
                                                    routeList[page].customUrl
                                                }
                                                showNavBar={showNavBar}
                                                showMMenu={showMMenu}   
                                                setOpenMobileDropdown={
                                                    setOpenMobileDropdown
                                                }
                                            />
                                        );
                                })}
                            {isAuthenticated && userRole === 'CUSTOMER' && (
                                <NavLink
                                    className={
                                        `px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                        (showNavBar
                                            ? `${
                                                  config?.navBarConfig
                                                      .stickyNavBar.itemClass ||
                                                  'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                              }`
                                            : ` ${
                                                  config.navBarConfig.baseNavBar
                                                      .itemClass ||
                                                  'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                              }`)
                                    }
                                    activeClassName={
                                        config.navBarConfig.showActiveLinkColor
                                            ? 'text-secondary-focus'
                                            : ''
                                    }
                                    to="/myprofile/info"
                                >
                                    My Profile
                                </NavLink>
                            )}
                            {isAuthenticated && userRole === 'CUSTOMER' && (
                                <NavLink
                                    className={
                                        `hidden lg:block px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                        (showNavBar
                                            ? `${
                                                  config?.navBarConfig
                                                      .stickyNavBar.itemClass ||
                                                  'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                              }`
                                            : ` ${
                                                  config.navBarConfig.baseNavBar
                                                      .itemClass ||
                                                  'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                              }`)
                                    }
                                    activeClassName={
                                        config.navBarConfig.showActiveLinkColor
                                            ? 'text-secondary-focus'
                                            : ''
                                    }
                                    to="/myprofile/docs"
                                >
                                    Documents
                                </NavLink>
                            )}

                            {isAuthenticated &&
                                userRole === 'CUSTOMER' &&
                                window.reloy_env.client_config.MY_PROFILE
                                    ?.SHOW_MY_PROPERTY && (
                                    <NavLink
                                        className={
                                            `hidden lg:block px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                            (showNavBar
                                                ? `${
                                                      config?.navBarConfig
                                                          .stickyNavBar
                                                          .itemClass ||
                                                      'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                                  }`
                                                : ` ${
                                                      config.navBarConfig
                                                          .baseNavBar
                                                          .itemClass ||
                                                      'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                                  }`)
                                        }
                                        activeClassName={
                                            config.navBarConfig
                                                .showActiveLinkColor
                                                ? 'text-secondary-focus'
                                                : ''
                                        }
                                        to="/myprofile/property"
                                    >
                                        My Property
                                    </NavLink>
                                )}
                            {isAuthenticated && userRole === 'CUSTOMER' && (
                                <NavLink
                                    className={
                                        `hidden lg:block px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                        (showNavBar
                                            ? `${
                                                  config?.navBarConfig
                                                      .stickyNavBar.itemClass ||
                                                  'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                              }`
                                            : ` ${
                                                  config.navBarConfig.baseNavBar
                                                      .itemClass ||
                                                  'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                              }`)
                                    }
                                    activeClassName={
                                        config.navBarConfig.showActiveLinkColor
                                            ? 'text-secondary-focus'
                                            : ''
                                    }
                                    to="/myprofile/enquiries"
                                >
                                    Enquiries
                                </NavLink>
                            )}
                            {isAuthenticated &&
                                (userRole === 'CUSTOMER' ||
                                    userRole == 'SITE_VISITOR') &&
                                config?.loginModal?.showSVLogin && (
                                    <NavLink
                                        className={
                                            `hidden lg:block px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                            (showNavBar
                                                ? `${
                                                      config?.navBarConfig
                                                          .stickyNavBar
                                                          .itemClass ||
                                                      'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                                  }`
                                                : ` ${
                                                      config.navBarConfig
                                                          .baseNavBar
                                                          .itemClass ||
                                                      'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                                  }`)
                                        }
                                        activeClassName={
                                            config.navBarConfig
                                                .showActiveLinkColor
                                                ? 'text-secondary-focus'
                                                : ''
                                        }
                                        to="/myprofile/site-visits"
                                    >
                                        Site Visits
                                    </NavLink>
                                )}
                            {isAuthenticated && (
                                <button
                                    onClick={logout}
                                    className={
                                        `px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                        (showNavBar
                                            ? `${
                                                  config?.navBarConfig
                                                      .stickyNavBar.itemClass ||
                                                  'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                              }`
                                            : ` ${
                                                  config.navBarConfig.baseNavBar
                                                      .itemClass ||
                                                  'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                              }`)
                                    }
                                    activeClassName={
                                        config.navBarConfig.showActiveLinkColor
                                            ? 'text-secondary-focus'
                                            : ''
                                    }
                                >
                                    Logout
                                </button>
                            )}
                            {!isAuthenticated && (
                                <button
                                    onClick={openLoginModal}
                                    className={`text-left px-6 w-full py-2 lg:p-0 lg:border-none lg:w-auto lg:mr-1  ${
                                        showNavBar
                                            ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                            : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                    }  `}
                                >
                                    Login
                                </button>
                            )}

                            {isAuthenticated && (
                                <div
                                    class="hidden lg:relative lg:inline-block "
                                    onMouseOver={() => setOpenMyProfile(true)}
                                    onMouseLeave={() => setOpenMyProfile(false)}
                                >
                                    <button
                                        className={
                                            'uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                            (showNavBar
                                                ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                        }
                                    >
                                        {getFormattedUserName(userName)}

                                        <svg
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            class={
                                                `${
                                                    openMyProfile
                                                        ? ' rotate-180'
                                                        : ' rotate-0'
                                                }` +
                                                ' inline w-4 h-4 mt-1 ml-1 transition-transform duration-200 transform md:-mt-1'
                                            }
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            ></path>
                                        </svg>
                                    </button>

                                    {openMyProfile && (
                                        <div
                                            class={`z-20 lg:absolute right-0 w-full transition-opacity duration-300  origin-top-right lg:rounded-md lg:shadow-lg md:w-48 `}
                                        >
                                            <div
                                                class={`px-2 lg:rounded-md lg:shadow ${
                                                    userRole === 'CUSTOMER'
                                                        ? 'lg:py-4'
                                                        : ''
                                                } ${
                                                    config?.navBarConfig
                                                        .dropDownBg
                                                        ? config?.navBarConfig
                                                              .dropDownBg
                                                        : 'bg-white'
                                                }`}
                                            >
                                                {/* {userRole === 'CUSTOMER' && ( */}
                                                <NavLink
                                                    to="/myprofile/docs"
                                                    className={` py-2 block px-4 bg-transparent rounded-lg md:mt-0 ${
                                                        config?.navBarConfig
                                                            .baseNavBar
                                                            .dropDownItemClass
                                                    }  ${
                                                        config?.navBarConfig
                                                            .baseNavBar
                                                            .dropDownContainerClass
                                                            ? config
                                                                  ?.navBarConfig
                                                                  .baseNavBar
                                                                  .dropDownContainerClass
                                                            : 'hover:text-gray-900 hover:bg-gray-200'
                                                    } `}
                                                >
                                                    My Profile
                                                </NavLink>
                                                {/* )} */}
                                                <a
                                                    onClick={logout}
                                                    className={`block px-4 py-2 lg:mt-2 bg-transparent rounded-lg md:mt-0 cursor-pointer ${
                                                        config?.navBarConfig
                                                            .baseNavBar
                                                            .dropDownItemClass
                                                    }  ${
                                                        config?.navBarConfig
                                                            .baseNavBar
                                                            .dropDownContainerClass
                                                            ? config
                                                                  ?.navBarConfig
                                                                  .baseNavBar
                                                                  .dropDownContainerClass
                                                            : 'hover:text-gray-900 hover:bg-gray-200'
                                                    } `}
                                                >
                                                    Logout
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {/* </Transition> */}
                                </div>
                            )}
                        </li>
                    </ul>
                </div>

                {/* RIGHT LOGO */}
                {config?.logoRight && (
                    <Link>
                        <div className=" cursor-pointer hidden lg:flex h-full items-center">
                            <img
                                src={config.logoRight.url}
                                className={
                                    '  object-contain ' +
                                    (showNavBar
                                        ? `${config.logoRight?.stickyNavBarLogoClass}`
                                        : `${config.logoRight?.baseNavBarLogoClass}`)
                                }
                            />
                        </div>
                    </Link>
                )}
            </header> 
            )}

        </>
    );
}

export default NavBar;
